import { render, staticRenderFns } from "./OpenBlockButBetter.vue?vue&type=template&id=bd4d5d90"
import script from "./OpenBlockButBetter.vue?vue&type=script&lang=js"
export * from "./OpenBlockButBetter.vue?vue&type=script&lang=js"
import style0 from "./OpenBlockButBetter.vue?vue&type=style&index=0&id=bd4d5d90&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports